module.exports = __webpack_public_path__ + "static/undraw_programming_2svr-dd951f98a27c689550a8775bcc374f44.svg";